import { formatStartEndHours } from "./formatStartEndHours";

export function formatStartEndSlotHours(
  { start, end }: { start: string | Date; end: string | Date },
  separator = "-"
): string {
  return formatStartEndHours(start, end).join(separator);
}
